export interface CashList {
  id: string;
  nursing_home_id: string;
}
export interface CashListTransactionGroupList {
  id: string;
  group_type: string;
  mismatch_confirmation_timestamp: string | null;
  amount_linked: number;
  linking_difference: number;
  separate_fee_amount_linked: number;
  separate_fee_amount_linking_difference: number;
  immediate_fee_amount_linked: number;
  immediate_fee_amount_linking_difference: number;
  cash_changed: number;
  separate_fee_amount: number;
  immediate_fee_amount: number;
  reversed: boolean;
  cash_list: CashList;
  open_receipt_count: number;
  open_receipt_batch_count: number;
}
export interface CashListTransaction {
  id: string;
  status: string | null;
  type: string;
  amount: number;
  immediate_fee_amount: number;
  separate_fee_amount: number;
  immediate_fee_tracked: boolean;
  separate_fee_percentage: string | null; // Decimal as string
  cash_list_id: string;
  group_id: string;
  employee_id: string;
  coin_change: number | null;
  bank_account_amount_change: number;
  notes: string | null;
  group_list: CashListTransactionGroupList;
  reversed: boolean;
}

export function filterCashListTransactions(
  cash_list_transactions: CashListTransaction[] | undefined,
  nursing_home_id: string | undefined
): CashListTransaction | undefined {
  if (!cash_list_transactions) {
    return undefined;
  }

  return cash_list_transactions
    .filter((cashListTransaction) => !cashListTransaction.group_list.reversed)
    .find(
      (cashListTransaction) =>
        cashListTransaction.group_list.cash_list.nursing_home_id ===
        nursing_home_id
    );
}
